<template>
  <div>
    <div class="Kanit primary pa-4 text-center white--text" style="font-size: 22px">
      แก้ไขเบอร์โทร
    </div>
    <div v-if="loading">
      <div class="text-center pt-10">
        <v-progress-circular color="primary" indeterminate size="60"></v-progress-circular>
      </div>
    </div>
    <div v-else>
      <div class="mb-0">
        <v-btn @click="back" text color="primary">
          <v-icon>mdi-chevron-left</v-icon>
          กลับ
        </v-btn>
      </div>
      <div class="pa-5 pt-1">
        <div>
          <div class="text-center mt-4 mb-6" style="font-size: 20px">
            กรอกรหัส OTP ที่ได้รับทาง SMS
            <div style="font-size: 19px">{{ phone }}</div>
          </div>

          <div class="text-center caption border-bottom mb-2">ref: {{ ref }}</div>
          <div class="text-center my-4 mb-6">กรอกรหัส OTP เพื่อยืนยันตัวตน</div>
        </div>

        <ValidationObserver ref="observer">
          <ValidationProvider
            :rules="{
              required: true,
            }"
            name="OTP"
            v-slot="{ errors }"
          >
            <custom-input v-model="input.otp" :center="true" placeholder="OTP" numberOnly outlined :error-messages="errors"></custom-input>
          </ValidationProvider>
        </ValidationObserver>
        <div class="text-center mb-2">
          <span v-if="showCountdowntimer" class="mr-2">นับเวลาถอยหลัง</span>
          <CountDownTimer style="font-size: 22px" v-if="showCountdowntimer" :startmin="timeleft" @ontimeout="showCountdowntimer = false"></CountDownTimer>
          <div v-else>OTP หมดอายุ</div>
        </div>

        <div class="mt-4 text-center">
          <v-btn :loading="saveloading" @click="submitOtp" style="font-size: 20px" class="text-capitalize" color="primary" dark>ยืนยัน</v-btn>
          <v-btn class="mt-2 w-100" style="font-size: 20px" :loading="resendloading" @click="resendotp">Resend OTP</v-btn>
        </div>
      </div>
    </div>
    <v-dialog width="350px" v-model="showCooldownTimeDialog">
      <v-card v-if="showCooldownTimeDialog" class="Kanit pa-4">
        <div class="text-center">
          เนื่องจากคุณได้รับรหัส OTP ไปแล้ว กรุณากรอกรหัส OTP อีกครั้งหลังจากเวลา
        </div>
        <div class="text-center">
          <CountDownTimer
            style="font-size: 22px"
            v-if="showCountdowntimer"
            :startmin="timeleft"
            @ontimeout="
              showCountdowntimer = false;
              showCooldownTimeDialog = false;
            "
          ></CountDownTimer>
          <span v-else style="font-size: 22px">00:00</span>
          <div class="text-center mt-2">
            <v-btn @click="showCooldownTimeDialog = false" color="primary">ปิด</v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import CountDownTimer from "@/components/CountDownTimer.vue";
export default {
  data() {
    return {
      timeleft: 0,
      loading: false,
      saveloading: false,
      showCooldownTimeDialog: false,
      resendloading: false,
      showCountdowntimer: false,
      ref: "",
    };
  },
  components: {
    CountDownTimer,
  },
  computed: {
    phone() {
      return this.$store.state.input.phoneNumber;
    },
    input() {
      return this.$store.state.input;
    },
    xxxphone() {
      return this.$store.state.input.phoneNumber.slice(this.$store.state.input.phoneNumber.length - 4);
    },
  },
  async mounted() {
    this.input.otp = "";
    var isOTPready = await this.$store.dispatch("isOTPready");

    if (isOTPready.status) {
      this.showCountdowntimer = false;

      await this.getOtp();
      this.timeleft = 3;
      this.showCountdowntimer = true;
    } else {
      this.timeleft = isOTPready.timeleft;
      this.showCountdowntimer = true;
      this.showCooldownTimeDialog = true;
    }
  },
  methods: {
    back() {
      this.query.tab = "profile";
      this.query.view = "PointManager";
    },
    resendotp() {
      this.getOtp();
    },
    getOtp() {
      return new Promise((resolve) => {
        var data = {
          userid: this.userid,
          pageid: this.query.pageid,
          // phoneNumber: this.$store.state.member.phoneNumber,
          phoneNumber: this.$store.state.input.phoneNumber,
        };
        this.loading = true;
        axios
          .post(this.serverUrl + "toacrm/request-otp", data, {
            headers: {
              AUTHORIZATION: "Bearer xxx xxx",
            },
          })
          .then(async (response) => {
            this.loading = false;
            if (response.data.responsecode == 200) {
              this.ref = response.data.data[0].referral;
            } else if (response.data.response == 204) {
              this.$swal.fire({ text: response.data.reason });
            } else {
              await this.$swal.fire({ text: response.data.reason });
              this.$liff.closeWindow();
            }
            resolve();
          });
      });
    },
    submitOtp() {
      return new Promise((resolve) => {
        var data = {
          userid: this.userid,
          pageid: this.query.pageid,
          referral: this.ref,
          otp: this.input.otp,
        };
        this.saveloading = true;
        axios
          .post(this.serverUrl + "toacrm/validate-otp", data, {
            headers: {
              AUTHORIZATION: "Bearer xxx xxx",
            },
          })
          .then(async (response) => {
            this.saveloading = false;
            if (response.data.responsecode == 200) {
              this.changeNumber();
              // await this.$store.dispatch("sendMessage", "ลงทะเบียนสำเร็จ");
              // await this.$liff.closeWindow();
              // this.$emit("nextstep");
            } else if (response.data.responsecode == 204) {
              await this.$swal.fire({ text: response.data.reason });
            } else {
              await this.$swal.fire({ text: response.data.reason });
              this.$liff.closeWindow();
            }
          });
      });
    },
    changeNumber() {
      var data = {
        memberId: this.$store.state.member.memberId,
        phoneNumber: this.input.phoneNumber,
      };
      this.saveloading = true;
      axios
        .put(this.serverUrl + "toacrm/change-phonenumber", data, {
          headers: {
            AUTHORIZATION: "Bearer xxx xxxx",
          },
        })
        .then(async (response) => {
          // this.input.phoneNumber = "";
          this.saveloading = false;
          if (response.data.responsecode == 200) {
            await this.$swal.fire({
              icon: "success",
              text: "เปลี่ยนเบอร์โทรศัพท์สำเร็จ",
            });
            this.$store.state.member.phoneNumber = this.input.phoneNumber;
            this.back();
            // await this.$liff.closeWindow();
          } else if (response.data.responsecode == 204) {
            await this.$swal.fire({ text: response.data.reason });
          } else {
            await this.$swal.fire({ text: response.data.reason });
            this.$liff.closeWindow();
          }
        });
    },
  },
};
</script>
<style></style>
